module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAATklEQVQ4T2PU6vj6hoGBQZiBPPCWUavj6/9rFdyM5OgH6R01gJphoNX59TLDfwYdomKDkeHKtXJuXZRYoNgAomxGUzSaDhgYqBYGFGVnAIQHcEtak+QUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete.png
// module id = 4b9t
// module chunks = 0